// Temporary event bus solution until we change to Vuex
// https://stackoverflow.com/questions/61034661/vue-js-how-can-i-emit-events-between-router-view-components
import Vue from 'vue';

export default new Vue();